<style scoped>
.btn.btn-md{
  background-color: rgb(245, 245, 245);
  border: 1px solid #868686 !important;  
}
.img.img-responsive.c-avatar-img {
  width: 100px !important;
}
</style>
<template>
  <CDropdown inNav class="c-header-nav-items" placement="bottom-end" add-menu-classes="pt-0">
    <template #toggler>
      <CHeaderNavLink>
        <div class="font-weight-bold text-white mr-3">{{ name ? name : '- - -' }}</div>
        <div class="c-avatar d-flex align-items-center">
          <img src="img/avatars/9.png" class="c-avatar-img" />
        </div>
      </CHeaderNavLink>
    </template>
    <CDropdownHeader tag="div" class="text-center p-5" style="background-color:#1a3665;">
      <div class="c-avatar align-items-center">
        <img src="img/avatars/9.png" class="img img-responsive c-avatar-img" />
      </div>
      <div class="font-weight-bold text-white">
        <h4>{{ name }}</h4>
      </div>
      <div class="text-white">{{ email ? email : '-'}}</div>
    </CDropdownHeader>

    <div class="d-flex align-items-center justify-content-center p-3 ">
      <router-link :to="'/user-manajemen/petugas-iapi-edit/'+idUser+'?type=profile'" >
      <button class="btn btn-sm font-weight-bold px-3 p-2 border mr-2">Profil</button>
      </router-link>
      <button @click.prevent="logOut" class="btn btn-sm font-weight-bold px-3 p-2 border">Keluar</button>
    </div>
  </CDropdown>
</template>

<script>
export default {
  name: "TheHeaderDropdownAccnt",
  data() {
    return {
      itemsCount: 42,
      name : '',
      email : '',
      idUser : ''
    };
  },
  mounted(){
    var  user = JSON.parse(localStorage.getItem('user'));
    this.name = user.name;
    this.email = user.email;
    this.idUser = user.userId;
  },
  methods: {
    // alertLogout() {
    //   this.$swal.fire({
    //     title: "Peringatan!",
    //     text: "Apakah anda yakin ingin keluar?",
    //     icon: "error",
    //     showCancelButton: true
    //   });
    // },

    logOut() {
      this.$swal
        .fire({
          title: "Peringatan!",
          text: "Apakah anda yakin ingin keluar?",
          icon: "info",
          showCancelButton: true,
          confirmButtonText: "Ya",
          cancelButtonText: "Tidak",
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          reverseButtons: true
        })
        .then(result => {
          if (result.value) {
            this.$store.dispatch("auth/logout");
            this.$router.push("/pages/login");
          }
        });
    }
  }
};
</script>

<style scoped>
.c-icon {
  margin-right: 0.3rem;
}
</style>